import * as React from "react";

const XlsDownload: React.FC = () => {
    return (
        <svg width={22} height={26} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#0071AD" d="M1 6H18V16H1z" />
            <path
                d="M21 18.5v-14L17 1H6v5m15 12.5h-3V6H6m15 12.5l-4.5 6L12 19M6 6H1v10h5m0 0v3h6m-6-3h8.5v3H12"
                stroke="#0071AD"
            />
            <path
                d="M3.468 7.91l1.313 2.117h.04l1.312-2.118h.726l-1.6 2.545L6.858 13h-.726l-1.312-2.078h-.04L3.468 13h-.725l1.64-2.546-1.64-2.545h.725zM7.661 13V7.91h.617v4.543h2.366V13H7.661zm6.722-3.818a.78.78 0 00-.363-.587c-.212-.139-.472-.209-.78-.209-.226 0-.423.037-.592.11a.945.945 0 00-.393.3.721.721 0 00-.14.436c0 .135.033.252.098.35a.86.86 0 00.253.241c.103.063.21.115.324.157.112.04.216.072.31.097l.517.139c.133.035.28.083.443.144.164.061.32.145.47.251.15.105.275.239.373.403.097.164.146.365.146.604 0 .275-.072.524-.216.746a1.471 1.471 0 01-.627.53c-.273.13-.605.195-.996.195-.365 0-.68-.058-.947-.176a1.509 1.509 0 01-.627-.492 1.405 1.405 0 01-.256-.733h.636a.797.797 0 00.194.477c.115.124.259.217.433.278.176.06.364.09.567.09.235 0 .446-.038.634-.115.187-.078.335-.185.445-.323a.766.766 0 00.164-.487.597.597 0 00-.142-.413 1.04 1.04 0 00-.373-.258 3.91 3.91 0 00-.5-.174l-.626-.18c-.398-.114-.713-.277-.945-.489-.232-.212-.348-.49-.348-.833 0-.285.077-.533.232-.745.155-.214.364-.38.626-.498.263-.119.558-.179.882-.179.329 0 .62.06.875.177.256.116.458.275.607.477.15.202.23.432.239.689h-.597z"
                fill="#fff"
            />
            <path fill="#0071AD" d="M15 16H18V20H15z" />
            <path d="M16.456 24.036l-3.969-5.23 7.87-.05-3.901 5.28z" fill="#0071AD" />
        </svg>
    );
};

export default React.memo(XlsDownload);
